import { TaskPriorityEnumValues } from 'projects/admin/src/app/shared/models/product-evaluation-tasks/enums/TaskPriorityEnumValues';
import { ProductEvaluationTaskStatusEnum } from "../../../shared/models/product-evaluation-tasks/enums/ProductEvaluationTaskStatusEnum";
import { TechnicalCriteriaEvaluationTypeEnum } from '../../../shared/models/product-evaluation-tasks/enums/TechnicalCriteriaEvaluationTypeEnum';
export class TaskDetails {
  status: Status
  priority: Priority
  taskId: number
  taskNumber: string
  duedate: Date
  ambassadorData: AmbassadorData
  haveAmbassador: boolean
  trackName: string
  creationDate: Date
  updateDate: Date
  approvalDate: Date
  assignedDate: Date
  requestNumber: string
  canViewRequest: boolean
  requestId: number
  evaluationTypeEnum: TechnicalCriteriaEvaluationTypeEnum
  modificationReasons: ModificationReason[]
  group: string
  instructions: string
  canDelete: boolean
  evaluationForm: string
  mainCategory: string
  subCategory: string
  totalProductsCount: number
  firstProdcutName: string
}

export interface Status {
  title: string
  statusCode: ProductEvaluationTaskStatusEnum
}

export interface Priority {
  id: number
  name: string
  code: TaskPriorityEnumValues
  icon: string
}

export interface AmbassadorData {
  name: string
  image: string
}

export interface ModificationReason {
  title: string
  reason: string
  date: string
  status: ProductEvaluationTaskStatusEnum
}
